import { render } from "./SlideCarousel.vue?vue&type=template&id=5e1c4e1c&scoped=true"
import script from "./SlideCarousel.vue?vue&type=script&lang=js"
export * from "./SlideCarousel.vue?vue&type=script&lang=js"

import "./SlideCarousel.vue?vue&type=style&index=0&id=5e1c4e1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1c4e1c"]])

export default __exports__